//noScroll
class SplideEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const mvOptions = {
      type: 'fade',
      speed: 2500,
      interval: 5000,
      autoplay: true,
      pagination: false,
      rewind: true,
      pauseOnHover: false,
    };
    const splide = new Splide(".mv-splide", mvOptions);
    splide.mount();

    const interviewOptions = {
      type: 'loop',
      focus: 0,
      cloneStatus: false,
      perMove: 1,
      speed: 1000,
      gap: '3rem',
      perPage: 3,
      start: 0,
      pagination: true,
      clone: 6,
      drag: false,
      updateOnMove: true,
      breakpoints: {
        767: {
          perPage: 1,
          gap: '2rem',
        },
      },
    };
    const interviewSplide = new Splide(".interview-splide", interviewOptions);
    const bar = interviewSplide.root.querySelector(".progress-bar");
    interviewSplide.on( 'mounted move', function () {
      var end  = interviewSplide.Components.Controller.getEnd() + 1;
      var rate = Math.min( ( interviewSplide.index + 1 ) / end, 1 );
      bar.style.width = String( 100 * rate ) + '%';
    } );
    interviewSplide.mount();
  }
}
